/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
import {forwardRef, useContext, useState} from 'react'

import cx from 'classnames'

import {ATOM_ICON_SIZES} from '@s-ui/react-atom-icon'
import AtomInput, {inputTypes} from '@s-ui/react-atom-input'
import Context from '@s-ui/react-context'
import VisuallyHidden from '@s-ui/react-primitive-visually-hidden'
import DynamicRendering from '@adv-mt/mt-perf-dynamic-rendering'
import IconSearch from '@adv-mt/mt-svg-icons/lib/Search'

import {BASE_ELEMENTS_TYPES, INPUT_SEARCH_FILTER_VEHICLE_ID, WRAPPER_CLASS_NAME} from '../../config.js'
import useOptions from './hooks/useOptions.js'
import MakeList from './MakeList/index.js'

const FormVehiclesMakeModel = forwardRef(({aggregations, design, onChange, options, value}, popoverContentRef) => {
  const [inputSearch, setInputSearch] = useState('')
  const {i18n} = useContext(Context)

  const {mostSearchedMakesGroup, restOfMakesGroup} = useOptions({inputSearch, options})

  const formVehiclesWrapperClassName = cx(`${WRAPPER_CLASS_NAME}`, `${WRAPPER_CLASS_NAME}--${design}`)

  const handleChangeSearch = e => {
    const {value} = e.target
    setInputSearch(value)
  }

  return (
    <div className={formVehiclesWrapperClassName} ref={popoverContentRef}>
      <div className={`${WRAPPER_CLASS_NAME}Search`}>
        <VisuallyHidden as={BASE_ELEMENTS_TYPES.LABEL} htmlFor={INPUT_SEARCH_FILTER_VEHICLE_ID}>
          {i18n.t('FILTERS.INPUT_SEARCH.LABEL')}
        </VisuallyHidden>
        <AtomInput
          autocomplete="off"
          autoFocus
          id={INPUT_SEARCH_FILTER_VEHICLE_ID}
          leftIcon={<IconSearch size={ATOM_ICON_SIZES.medium} />}
          onChange={handleChangeSearch}
          value={inputSearch}
          type={inputTypes.SEARCH}
        />
      </div>
      <MakeList
        aggregations={aggregations}
        onChange={onChange}
        options={Array.from(mostSearchedMakesGroup)}
        title="Marcas más populares"
        value={value}
      />
      <DynamicRendering height={400}>
        <MakeList
          aggregations={aggregations}
          onChange={onChange}
          options={Array.from(restOfMakesGroup)}
          title="Resto de marcas"
          value={value}
        />
      </DynamicRendering>
    </div>
  )
})

export default FormVehiclesMakeModel
